import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import CheckboxChoices from "./CheckboxChoices";
import RadioChoices from "./RadioChoices";
import BreedChoices from "./BreedChoices";
import Snackbar from "@mui/material/Snackbar";
import { connect } from "react-redux";
import { selectSelectedValues } from "..//state/selectors";
import { setNextPage, setStatus } from "../state/domains";
import { fetchQuestions, fetchResult } from "../state/middleware";
import Box from "@mui/material//Box";
import LinearProgress from "@mui/material//LinearProgress";

const QuestionCard = props => {
  const {
    _fetchQuestions,
    totalPages,
    page,
    pageData,
    _setNextPage,
    _setStatus,
    loading,
    petType,
  } = props;
  const [errorStatus, setErrorStatus] = useState({
    open: 0,
  });

  const ValidateForm = () => {
    if (!selectSelectedValues().filter(val => val > 2).length) {
      setErrorStatus(() => {
        return {
          open: 1,
          message: "Select At Least One Choice other than gender....",
        };
      });
      return false;
    }
    return true;
  };

  function handleSubmit() {
    if (ValidateForm()) _setStatus(2);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }
  useEffect(() => {
    function setData() {
      if (
        !pageData.length ||
        !pageData.filter(card => card.page === page).length
      ) {
        _fetchQuestions(page);
      }
    }
    setData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const quizCards = pageData.map((card, index) => {
    switch (card.type) {
      case "check":
        return <CheckboxChoices key={`question-${index}`} card={card} />;
      case "radio":
        return <RadioChoices key={`question-${index}`} card={card} />;
      case "breed":
        return (
          <BreedChoices
            petType={petType}
            key={`question-${index}`}
            card={card}
          />
        );
      default:
        return <div></div>;
    }
  });
  if (loading)
    return (
      <Box sx={{ width: "100%", position: "absolute", top: "50%" }}>
        <LinearProgress />
      </Box>
    );
  else
    return (
      <>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ pt: "1.5vh" }}>
          {quizCards}
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="center">
            <Grid item>
              {page - 1 > 0 ? (
                <Button
                  color="button"
                  variant="contained"
                  onClick={e => {
                    _setNextPage(page - 1);
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                  }}>
                  Previous
                </Button>
              ) : (
                <div></div>
              )}
            </Grid>
            <Grid item>
              {page === totalPages ? (
                <Button
                  variant="contained"
                  color="button"
                  onClick={handleSubmit}>
                  Generate
                </Button>
              ) : (
                <div></div>
              )}
            </Grid>
            <Grid item>
              {page === totalPages ? (
                <Button
                  variant="contained"
                  color="button"
                  onClick={e => {
                    _setStatus(3);
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                  }}>
                  I feel Lucky
                </Button>
              ) : (
                <div></div>
              )}
            </Grid>
            <Grid item>
              {totalPages - page > 0 ? (
                <Button
                  variant="contained"
                  onClick={e => {
                    _setNextPage(page + 1);
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                  }}>
                  Next
                </Button>
              ) : (
                <div></div>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          open={errorStatus.open}
          autoHideDuration={6000}
          onClose={() => {
            setErrorStatus(() => {
              return { open: 0 };
            });
          }}
          message={errorStatus.message}
        />
      </>
    );
};
QuestionCard.propTypes = {};
const mapStateToProps = state => {
  const { currentPage: page, totalPages } = state.questions;
  let pageData = state.questions.quizQuestionData.filter(
    card => card.page === page
  );

  return {
    page,
    pageData,
    totalPages,
    loading: state.questions.loading,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    _fetchQuestions: page => dispatch(fetchQuestions(page)),
    _fetchResult: selectedData => dispatch(fetchResult(selectedData)),
    _setNextPage: page => dispatch(setNextPage(page)),
    _setStatus: status => dispatch(setStatus(status)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(QuestionCard);
